import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[60px] w-full rounded-md border border-[#dadbd5] bg-white px-3 py-2 text-base text-[#1c2620] shadow-[0_1px_2px_rgba(28,38,32,0.04)] transition-[border-color,box-shadow] placeholder:text-[#a8aea3] hover:border-[#c5c8bf] focus-visible:outline-none focus-visible:border-[#2d6a4f] focus-visible:ring-[3px] focus-visible:ring-[#2d6a4f]/15 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }
